import {
  transformConditionsFromBackend,
  transformConditionsToBackend,
} from '@/common/components/ConditionsEditor/helpers'
import { booleanFields } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/VisibilityCriterionDetailConfiguration/constants'

export const transformResponseGetVisibilityCriterion = criterion => {
  return {
    id: criterion.id,
    internal_id: criterion.internal_id,
    name: criterion.name,
    description: criterion.description,
    conditions: transformConditionsFromBackend(criterion.conditions, { booleanFields }),
    block_uids: criterion.block_uids,
  }
}

const mapVisibilityCriterionRequest = (criterion, defaultCurrency) => {
  return {
    name: criterion.name,
    description: criterion.description,
    conditions: transformConditionsToBackend(criterion.conditions, { defaultCurrency }),
  }
}

export const transformRequestCreateVisibilityCriterion = ({ storeId, criterion, defaultCurrency }) => {
  return { storeId, criterion: mapVisibilityCriterionRequest(criterion, defaultCurrency) }
}

export const transformRequestEditVisibilityCriterion = ({ storeId, criterionId, criterion, defaultCurrency }) => {
  return { storeId, criterionId, criterion: mapVisibilityCriterionRequest(criterion, defaultCurrency) }
}
